import moment from "moment/moment";
import { DisconnectionPropertyDetails } from "../../../../types/DisconnectionPropertyDetails";

export const withNaCheck = (input: string) => {
  return input ? input : "N/A";
};

export const mapAccessIssuesForDisplay = (
  guardDogs: boolean,
  lockedGate: boolean,
): string => {
  const guardDogName = guardDogs ? "Guard dog(s)" : "";
  const lockedGateName = lockedGate ? "Locked gates" : "";
  return withNaCheck(
    [guardDogName, lockedGateName].filter((str) => str).join(", "),
  );
};

export const mapAccessIssues = (
  values: DisconnectionPropertyDetails,
): string => {
  return mapAccessIssuesForDisplay(values.guardDogs, values.lockedGate);
};

export const formatDateForDisplay = (input: string) => {
  return input ? moment(input, "YYYY-MM-DD").format("DD/MM/YYYY") : input;
};
